import { renderToString } from "react-dom/server";
import { IRootState } from "../../types/redux/IRootStore";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";

export default function Footer() {
    const apiVersion = useSelector((state: IRootState) => state.auth.version);
    const aplSettings = AplSettingsSelector();

    if (!aplSettings.isUsSite && apiVersion.length > 0 && apiVersion !== (process.env.REACT_APP_VERSION ?? "")) {
        return (
            <div>
                <div className="container mw-100 pb-3">
                    <div className="row">
                        <div className="col-4"></div>
                        <div className="col-4 text-center">
                            APL {process.env.REACT_APP_VERSION ?? "2023"}
                        </div>
                        <div className="col-4">
                            <Tooltip id={`apl-version-update-tooltip`} html={renderToString(<span>Load APL {apiVersion}</span>)} />
                            <button
                                className="btn btn-sm btn-danger float-right"
                                data-tooltip-delay-hide={333}
                                data-tooltip-id={`apl-version-update-tooltip`}
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                    fill="currentColor"
                                    className="bi bi-arrow-clockwise"
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (aplSettings.isUsSite && apiVersion.length > 0 && apiVersion !== (process.env.REACT_APP_VERSION ?? "")) {
        return (
            <div>
                <div className="container mw-100 pb-3">
                    <div className="row">
                        <div className="col-4"></div>
                        <div className="col-4 text-center">
                            APL {process.env.REACT_APP_VERSION ?? "2023"}
                        </div>
                        <div className="col-4">
                            <Tooltip
                                id={`apl-version-update-tooltip`}
                                html={renderToString(<span className="float-right">{apiVersion}</span>)}
                            />
                            <div
                                data-tooltip-delay-hide={333}
                                data-tooltip-id={`apl-version-update-tooltip`}
                                className="float-right text-danger"
                            >
                                Please press F5 to load new version
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mw-100 pb-3">
            <div className="row">
                <div className="col-4"></div>
                <div className="col-4 text-center">
                    APL {process.env.REACT_APP_VERSION ?? "2023"}
                </div>
                <div className="col-4"></div>
            </div>
        </div>
    );
}
